import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
    path: '',
    component: () => import_latest_version_module(),
    children: [
        {
            path: '/admin/contacts',
            name: 'admin-contacts',
            component: () => import(/* webpackChunkName: "page-admin-default-contacts" */ `./index.vue`),
            meta: {
                data_for_admin_layout: {
                    data_for_history_tag: {
                        entity: {
                            name: "通讯录"
                        }
                    },
                    data_for_breadcrumb: {
                        entity_list: [
                            {
                                name: "示例功能"
                            },
                            {
                                name: "通讯录"
                            }
                        ]
                    }
                }
            },

        },
    ],
};

